module.exports = __webpack_public_path__ + "img/horizontal_7_3_pp3_8004.f3817fa4.png";